import ButtonIcon, { StyledButtonIcon } from '@tmh-website/ui/ButtonIcon';
import styled, { css } from 'styled-components';

// This stays here so that we can reference it in other components
export const Container = styled.address``;

interface UlProps {
  'aria-label': string;
  $align?: 'left' | 'center' | 'right';
  $centeredAt?: string;
}

export const Ul = styled.ul<UlProps>`
  display: flex;
  flex-wrap: wrap;
  ${props => props.$align === 'center' && 'justify-content: center;'};
  ${props => props.$align === 'right' && 'justify-content: flex-end;'};
  padding: 0;
  margin: -10px;
  overflow: hidden;
  list-style: none;
  ${props =>
    props.$centeredAt &&
    css`
      @media (${props.$centeredAt}) {
        justify-content: center;
      }
    `};

  > * {
    margin: 2px;
  }
`;

export const SocialButton = styled(ButtonIcon)<{ $iconOpacity?: number }>`
  ${props =>
    props.$iconOpacity &&
    css`
      svg {
        opacity: ${props.$iconOpacity};
      }

      &:hover {
        svg {
          opacity: 1;
        }
      }
    `};
`;
